class CartDrawerUpsell {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest(
        '[data-upsell-variant-id]'
      );

      if (!button) return;

      event.preventDefault();

      const variantId = button.dataset.upsellVariantId;

      if (!variantId) return;

      this.addToCart(variantId, button);
    });
  }

  async addToCart(variantId, button) {
    if (button.disabled) return;

    button.disabled = true;
    button.textContent = 'ADDING...';

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);

        throw new Error(
          errorData?.description || 'Unable to add product'
        );
      }

      button.textContent = '✓ ADDED';

      await this.refreshCartDrawer();

    } catch (error) {
      console.error('Upsell add error:', error);

      button.disabled = false;
      button.textContent = '+ ADD';
    }
  }

  async refreshCartDrawer() {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`
      );

      if (!response.ok) {
        throw new Error('Unable to refresh cart drawer');
      }

      const sections = await response.json();

      const cartDrawer = document.querySelector('cart-drawer');

      if (!cartDrawer) {
        throw new Error('Cart drawer not found');
      }

      /*
       * Refresh the drawer contents
       */
      if (sections['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(
          sections['cart-drawer'],
          'text/html'
        );

        const newDrawer = parsed.querySelector('#CartDrawer');
        const currentDrawer = document.querySelector('#CartDrawer');

        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
      }

      /*
       * Refresh cart icon / count
       */
      if (sections['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(
          sections['cart-icon-bubble'],
          'text/html'
        );

        const newBubble = parsed.querySelector(
          '#cart-icon-bubble'
        );

        const currentBubble = document.querySelector(
          '#cart-icon-bubble'
        );

        if (newBubble && currentBubble) {
          currentBubble.replaceWith(newBubble);
        }
      }

    } catch (error) {
      console.error(
        'Cart drawer refresh error:',
        error
      );
    }
  }
}


document.addEventListener(
  'DOMContentLoaded',
  () => {
    new CartDrawerUpsell();
  }
);